import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYahooComponent } from './simple-icons-yahoo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYahooComponent ],
    exports:      [ SimpleIconsYahooComponent ],
    bootstrap:    []
})
export class SimpleIconsYahooModule {}
